import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { ModuleBranchId, ModulesApi } from './modules';

// Paths mirror subsystems/platform/facade/adapters/admin-api/src/admin/modules.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey });
const inst = (b: ModuleBranchId, m: string, k: string) => `/modules/${seg(b)}/${seg(m)}/instances/${seg(k)}`;

export const modulesHttp: ModulesApi = {
  getModules: (opts) => http.get('api', '/modules', rd(opts)),
  getModuleBranch: (branch, opts) => http.get('api', `/modules/${seg(branch)}`, rd(opts)),
  getModuleInstance: (b, m, k, opts) => http.get('api', inst(b, m, k), rd(opts)),
  listModuleVersions: (b, m, k, query, opts) => http.get('api', `${inst(b, m, k)}/versions`, { query: { ...query }, ...rd(opts) }),
  listModuleCalls: (b, m, k, query, opts) => http.get('api', `${inst(b, m, k)}/calls`, { query: { ...query }, ...rd(opts) }),
  listModuleWebhooks: (b, m, k, query, opts) => http.get('api', `${inst(b, m, k)}/webhooks`, { query: { ...query }, ...rd(opts) }),
  createModuleInstance: (b, m, body, opts) => http.post('api', `/modules/${seg(b)}/${seg(m)}/instances`, body, wr(opts)),
  saveModuleDraft: (b, m, k, body, opts) => http.post('api', `${inst(b, m, k)}/versions`, body, wr(opts)),
  proposeModuleVersion: (b, m, k, id, body, opts) => http.post('api', `${inst(b, m, k)}/versions/${seg(id)}/propose`, body, wr(opts)),
  testModuleInstance: (b, m, k, body, opts) => http.post('api', `${inst(b, m, k)}/test`, body, wr(opts)),
  disableModuleInstance: (b, m, k, body, opts) => http.post('api', `${inst(b, m, k)}/disable`, body, wr(opts)),
  enableModuleInstance: (b, m, k, body, opts) => http.post('api', `${inst(b, m, k)}/enable`, body, wr(opts)),
  runModuleAction: (b, m, k, action, body, opts) => http.post('api', `${inst(b, m, k)}/actions/${seg(action)}`, body, { signal: opts?.signal }),
};
